import React from 'react';
import { DashboardProps } from '../../types';
import DashboardStage from './dashboard-stage';
import styles from './demo-dashboard.module.css';

const Dashboard: React.FC<DashboardProps> = ({ currentStage, onNextStage }) => {
  return (
    <div className={styles.dashboardDemo}>
      <div className={styles.dashboardContainer}>
        <DashboardStage 
          stage={1} 
          isActive={currentStage === 1} 
          onNext={onNextStage}
        />
        <DashboardStage 
          stage={2} 
          isActive={currentStage === 2} 
          onNext={onNextStage}
        />
        <DashboardStage 
          stage={3} 
          isActive={currentStage === 3} 
          onNext={onNextStage}
        />
      </div>
    </div>
  );
};

export default Dashboard; 